import Papa from "papaparse";

const stripDiacritics = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const CSV_FORMULA_PREFIX = /^[=+\-@\t\r]/;

export const toCsvSafeCell = (value) => {
  if (value == null) return "";
  const text = String(value);
  if (CSV_FORMULA_PREFIX.test(text)) return `'${text}`;
  return text;
};

export const downloadCsvFile = ({ fields, data, fileName, fallbackName }) => {
  const csv = Papa.unparse({ fields, data });
  const blob = new Blob([`\uFEFF${csv}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const rawName = String(fileName || fallbackName);
  link.download = stripDiacritics(rawName)
    .replace(/[^\w.-]+/g, "-")
    .replace(/-+/g, "-");
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
